import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  tone?: "primary" | "accent" | "secondary" | "muted";
  size?: "sm" | "md";
}

const tones: Record<NonNullable<BadgeProps["tone"]>, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  muted: "bg-background-100 text-foreground-600 border-background-200",
};

export default function Badge({ children, tone = "muted", size = "sm" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border font-label ${
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-xs"
      } ${tones[tone]}`}
    >
      {children}
    </span>
  );
}